import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';



export const fetchAll = createAsyncThunk('foodPackages/fetchAll', async (payload, { dispatch, getState }) => {
  try {
    const state = getState();

    const res = await FNS.getFoodPackages();
    dispatch(foodPackagesSlice.actions.replaceAll({ values: res }));

  } catch(e) {
    toast.error(e);
  }
});

export const ensureAll = createAsyncThunk('foodPackages/ensureAll', async (payload, { dispatch, getState }) => {
  try {
    const state = getState();
    console.log("fetching all foodPackages");

    if(state.foodPackages.haveAll) return;

    const res = await FNS.getFoodPackages();
    dispatch(foodPackagesSlice.actions.replaceAll({ values: res }));

  } catch(e) {
    toast.error(e);
  }
});

export const create = createAsyncThunk('foodPackages/add', async ({ name, description, price }, { dispatch }) => {
  try {

    const res = await FNS.addFoodPackage(name, description, price);
    const { id } = res;
    await dispatch(fetchAll());
    return id;

  } catch(e) {
    toast.error(e);
  }
});

export const update = createAsyncThunk('foodPackages/update', async ({ id, name, description, price }, { dispatch }) => {
    try {

      const res = await FNS.updateFoodPackage(id, name, description, price);
      await dispatch(fetchAll());

    } catch(e) {
      toast.error(e);
    }
  });

export const toggleFoodPackageHidden = createAsyncThunk('foodPackages/toggleFoodPackageHidden', async ({ id, hidden }, { dispatch }) => {
  try {

    await FNS.toggleFoodPackageHidden(id, hidden);
    await dispatch(fetchAll());

  } catch(e) {
    toast.error(e);
  }
});


const foodPackagesSlice = createSlice({
  name: 'foodPackages',
  initialState: {
    haveAll: false,
    knownFoodPackages: {}
  },
  reducers: {
    replaceAll: (state, { payload: { values } }) => {
      state.haveAll = true;
      let newFoodPackages = {};
      for(const foodPackage of values) {
        newFoodPackages[foodPackage.food_package_id] = foodPackage;
      }
      state.knownFoodPackages = newFoodPackages;
    },
    addFoodPackage: (state, { payload: { values } }) => {
      for(const foodPackage of values) {
        state.knownFoodPackages[foodPackage.food_package_id] = foodPackage;
      }
    }
  },
});

export default foodPackagesSlice.reducer;
